import { Type } from "@sinclair/typebox";
export const sitePointSchema = Type.Tuple([
    Type.Number({ minimum: -180, maximum: 180 }),
    Type.Number({ minimum: -90, maximum: 90 })
]);
const commonSave = {
    expectedVersion: Type.Integer({ minimum: 0 }),
    address: Type.String({ minLength: 3, maxLength: 500, pattern: "\\S.*\\S" }),
    selectionPoint: Type.Optional(sitePointSchema)
};
export const siteSaveSchema = Type.Union([
    Type.Object({ ...commonSave, candidateId: Type.String({ minLength: 1, maxLength: 180 }) }, { additionalProperties: false }),
    Type.Object({
        ...commonSave,
        manualPoint: sitePointSchema,
        reverseRequestId: Type.Optional(Type.String({ format: "uuid" }))
    }, { additionalProperties: false })
]);
export const siteCandidateSchema = Type.Object({
    id: Type.String(),
    point: sitePointSchema,
    address: Type.String(),
    kind: Type.Union([Type.Literal("access"), Type.Literal("civic")]),
    sourceLabel: Type.String(),
    releaseKey: Type.String(),
    observedAt: Type.String(),
    relation: Type.Literal("spatial_proximity"),
    distanceMeters: Type.Number(),
    accessDescription: Type.Union([Type.String(), Type.Null()]),
    anncsuAccessId: Type.Union([Type.String(), Type.Null()]),
    reconciliation: Type.Union([
        Type.Literal("source_id"),
        Type.Literal("address_components"),
        Type.Literal("ambiguous"),
        Type.Literal("unmatched")
    ])
});
export const confirmedSiteSchema = Type.Object({
    point: sitePointSchema,
    selectionPoint: Type.Union([sitePointSchema, Type.Null()]),
    address: Type.String(),
    source: Type.Union([Type.Literal("regional_candidate"), Type.Literal("manual")]),
    candidate: Type.Union([siteCandidateSchema, Type.Null()]),
    geocodingRequestId: Type.Union([Type.String(), Type.Null()]),
    confirmedAt: Type.String(),
    confirmedBy: Type.String()
});
export const buildingSiteSchema = Type.Object({
    buildingId: Type.String({
        pattern: "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
    }),
    version: Type.Integer({ minimum: 0 }),
    confirmed: Type.Union([confirmedSiteSchema, Type.Null()]),
    candidates: Type.Array(siteCandidateSchema, { maxItems: 20 }),
    coverage: Type.Union([
        Type.Literal("available"),
        Type.Literal("outside_pilot"),
        Type.Literal("no_candidates")
    ])
});
export function normalizeSiteText(value) {
    return value
        .normalize("NFKC")
        .toLocaleUpperCase("it-IT")
        .replace(/[^\p{L}\p{N}]+/gu, " ")
        .trim();
}
//# sourceMappingURL=building-site.js.map